import { useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS } from "@/data/content";

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let pending = null;

// Uploaded images are served by the backend under /api/media; bundled images live in /public.
export const assetUrl = (u) => (u && u.startsWith("/api/") ? `${API}${u}` : u);

const fetchProducts = () => {
  if (!pending) {
    pending = axios
      .get(`${API}/api/products`)
      .then((r) => (Array.isArray(r.data) ? r.data : PRODUCTS))
      .catch(() => PRODUCTS)
      .then((list) => {
        cache = list;
        pending = null;
        return list;
      });
  }
  return pending;
};

export const refreshProducts = () => {
  cache = null;
  return fetchProducts();
};

export const useProducts = ({ featured } = {}) => {
  const [list, setList] = useState(cache);
  useEffect(() => {
    let alive = true;
    if (!cache) fetchProducts().then((l) => alive && setList(l));
    return () => {
      alive = false;
    };
  }, []);
  if (!list) return null;
  return featured ? list.filter((p) => p.featured) : list;
};

export const priceLabel = (p) => `$${p.price}${p.price_max ? `–$${p.price_max}` : ""}`;
